const getDropdownValues = (list) =>
  list?.map((value) => ({
    label: value,
    value,
    isFixed: true,
  })) ?? [];

export default getDropdownValues;
